"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp; /**
                    * Copyright 2013-present, Novivia, Inc.
                    * All rights reserved.
                    */

var _i18next2 = require("i18next");

var _filesize = require("filesize");

var _filesize2 = _interopRequireDefault(_filesize);

var _i18nextCallbackBackend = require("i18next-callback-backend");

var _i18nextCallbackBackend2 = _interopRequireDefault(_i18nextCallbackBackend);

var _momentTimezone = require("moment-timezone");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A module providing tools to manage localization utilities.
 */

var LocaleManager = (_temp = _class = function () {
  function LocaleManager(_ref) {
    var _ref$defaultCurrency = _ref.defaultCurrency,
        defaultCurrency = _ref$defaultCurrency === undefined ? "USD" : _ref$defaultCurrency,
        i18nextConfiguration = _ref.i18nextConfiguration,
        _ref$i18nextOptions = _ref.i18nextOptions,
        _ref$i18nextOptions$f = _ref$i18nextOptions.fallbackLanguage,
        fallbackLanguage = _ref$i18nextOptions$f === undefined ? ["en-US", "en"] : _ref$i18nextOptions$f,
        _ref$i18nextOptions$u = _ref$i18nextOptions.useCustomLoader,
        useCustomLoader = _ref$i18nextOptions$u === undefined ? true : _ref$i18nextOptions$u,
        otherI18nextOptions = (0, _objectWithoutProperties3.default)(_ref$i18nextOptions, ["fallbackLanguage", "useCustomLoader"]),
        _ref$locale = _ref.locale,
        locale = _ref$locale === undefined ? "en-US" : _ref$locale;
    (0, _classCallCheck3.default)(this, LocaleManager);

    this.fullLocale = locale;
    this.defaultCurrency = defaultCurrency;
    this.i18nextOptions = (0, _extends3.default)({
      fallbackLanguage: fallbackLanguage,
      useCustomLoader: useCustomLoader
    }, otherI18nextOptions);
    this.i18nextConfiguration = i18nextConfiguration;
  }

  (0, _createClass3.default)(LocaleManager, [{
    key: "formatDate",


    // FIXME: Investigate using
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat

    /**
     * Format a date to a string based on locale.
     */
    value: function formatDate() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$format = _ref2.format,
          format = _ref2$format === undefined ? "LLL" : _ref2$format,
          _ref2$locale = _ref2.locale,
          locale = _ref2$locale === undefined ? this.fullLocale : _ref2$locale,
          output = _ref2.output,
          timezone = _ref2.timezone;

      var currentTimezone = this.getCurrentTimezone(timezone);
      var momentDate = LocaleManager.getNewMoment(date);

      if (currentTimezone) {
        momentDate.tz(currentTimezone);
      }

      momentDate.locale(locale);

      var showTimezone = currentTimezone && /[hH][^dDMY]+$/.test(momentDate.localeData().longDateFormat(format));
      var formattedDate = momentDate.format(format);
      var formattedTimezone = showTimezone ? momentDate.zoneAbbr() : "";

      if (output === "object") {
        return {
          date: formattedDate,
          timezone: formattedTimezone
        };
      }

      return "" + formattedDate + (formattedTimezone ? "\xA0" + formattedTimezone : "");
    }

    /**
     * Format a file size to a string based on locale.
     */

  }, {
    key: "formatFilesize",
    value: function formatFilesize(filesize) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          base = _ref3.base,
          bits = _ref3.bits,
          _ref3$locale = _ref3.locale,
          locale = _ref3$locale === undefined ? this.fullLocale : _ref3$locale,
          _ref3$spacer = _ref3.spacer,
          spacer = _ref3$spacer === undefined ? true : _ref3$spacer,
          _ref3$standard = _ref3.standard,
          standard = _ref3$standard === undefined ? "iec" : _ref3$standard,
          unix = _ref3.unix,
          settings = (0, _objectWithoutProperties3.default)(_ref3, ["base", "bits", "locale", "spacer", "standard", "unix"]);

      var filesizeInfo = (0, _filesize2.default)(filesize, {
        base: base,
        bits: bits,
        output: "object",
        standard: standard,
        unix: unix
      });

      var formattedSize = this.formatNumber(filesizeInfo.value, (0, _extends3.default)({
        locale: locale
      }, LocaleManager.defaultFilesizeFormatSettings, settings));

      return "" + formattedSize + (spacer ? "\xA0" : "") + filesizeInfo.suffix;
    }

    /**
     * Format a currency to a string based on locale.
     */

  }, {
    key: "formatMoney",
    value: function formatMoney(amount) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$currency = _ref4.currency,
          currency = _ref4$currency === undefined ? this.defaultCurrency : _ref4$currency,
          _ref4$locale = _ref4.locale,
          locale = _ref4$locale === undefined ? this.fullLocale : _ref4$locale,
          settings = (0, _objectWithoutProperties3.default)(_ref4, ["currency", "locale"]);

      // FIXME: Memoize/cache the formatter for a given setting combination.
      return new Intl.NumberFormat(locale, (0, _extends3.default)({
        currency: currency,
        style: "currency"
      }, settings)).format(amount);
    }

    /**
     * Format a number to a string based on locale.
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$locale = _ref5.locale,
          locale = _ref5$locale === undefined ? this.fullLocale : _ref5$locale,
          settings = (0, _objectWithoutProperties3.default)(_ref5, ["locale"]);

      // FIXME: Memoize/cache the formatter for a given setting combination.
      return new Intl.NumberFormat(locale, (0, _extends3.default)({}, LocaleManager.defaultNumberFormatSettings, settings)).format(number);
    }

    /**
     * Format a number to a string based on locale.
     */

  }, {
    key: "formatPercentage",
    value: function formatPercentage(percentage) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$locale = _ref6.locale,
          locale = _ref6$locale === undefined ? this.fullLocale : _ref6$locale,
          settings = (0, _objectWithoutProperties3.default)(_ref6, ["locale"]);

      // FIXME: Memoize/cache the formatter for a given setting combination.
      return new Intl.NumberFormat(locale, (0, _extends3.default)({
        style: "percent"
      }, settings)).format(percentage);
    }
  }, {
    key: "getCurrentLanguage",
    value: function getCurrentLanguage() {
      return this.i18next.language;
    }
  }, {
    key: "getCurrentLocale",
    value: function getCurrentLocale() {
      return this.fullLocale;
    }
  }, {
    key: "getCurrentTimezone",
    value: function getCurrentTimezone(timezone) {
      if (timezone === false) {
        return;
      }

      if (timezone && timezone !== true) {
        return timezone;
      }

      // Timezone is either not set, or set to true.
      return this.guessCurrentTimezone();
    }
  }, {
    key: "getLanguageKey",
    value: function getLanguageKey() {
      var _i18next;

      return (_i18next = this.i18next).t.apply(_i18next, arguments);
    }
  }, {
    key: "getTimezoneData",
    value: function getTimezoneData() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timezone = _ref7.timezone;

      var currentTimezone = this.getCurrentTimezone(timezone);
      var momentDate = LocaleManager.getNewMoment(date);

      if (currentTimezone) {
        momentDate.tz(currentTimezone);
      }

      var abbreviation = momentDate.zoneAbbr();
      var offsetRaw = momentDate.utcOffset();
      var offset = offsetRaw / 60;
      var offsetString = "" + (offset > 0 ? "+" : "") + offset;

      return {
        abbreviation: abbreviation,
        offset: offset,
        offsetRaw: offsetRaw,
        offsetString: offsetString,
        timezone: "" + offsetString + (abbreviation ? "\xA0(" + abbreviation + ")" : "")
      };
    }
  }, {
    key: "guessCurrentTimezone",
    value: function guessCurrentTimezone() {
      return "";
    }
  }, {
    key: "initialize",
    value: function initialize() {
      // This is a bit tricky, there might we some async stuff going on during
      // initialization, but we don't want to impose an async contructor, neither
      // do we want to put the initialization burden on the user. Basically, we
      // trigger the initialization ourselves but make the result publicly
      // available in a promise.
      return this.ready = this.initializeInternally();
    }
  }, {
    key: "initializeInternally",
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _promise2.default.all([this.initializeI18next(), this.initializeIntlPolyfill()]);

              case 2:
                _context.next = 4;
                return this.changeLocale({ locale: this.fullLocale });

              case 4:
                return _context.abrupt("return", this);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function initializeInternally() {
        return _ref8.apply(this, arguments);
      };
    }()
  }, {
    key: "initializeI18next",
    value: function initializeI18next() {
      var _this = this;

      this.i18next = (0, _i18next2.createInstance)();

      if (this.i18nextOptions.useCustomLoader) {
        this.i18next.use(_i18nextCallbackBackend2.default);
      }

      this.attachI18nextMiddleware();

      return new _promise2.default(function (resolve, reject) {
        return _this.i18next.init(_this.getI18nextConfiguration(), function (err) {
          if (err) {
            return reject(err);
          }

          resolve();
        });
      });
    }
  }, {
    key: "changeLocale",
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref9) {
        var locale = _ref9.locale;
        return _regenerator2.default.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.ensureLocaleIsLoaded({ locale: locale });

              case 2:
                _momentTimezone2.default.locale(locale);
                this.fullLocale = locale;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function changeLocale() {
        return _ref10.apply(this, arguments);
      };
    }()
  }, {
    key: "ensureLocaleIsLoaded",
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function (_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function ensureLocaleIsLoaded() {
        return _ref11.apply(this, arguments);
      };
    }()
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        return _this2.i18next.changeLanguage(locale, function (err) {
          return err ? reject(err) : resolve();
        });
      });
    }
  }], [{
    key: "getNewMoment",
    value: function getNewMoment() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

      return LocaleManager.moment(date);
    }
  }]);
  return LocaleManager;
}(), _class.defaultFilesizeFormatSettings = {
  maximumFractionDigits: 2
}, _class.defaultNumberFormatSettings = {
  maximumFractionDigits: 0
}, _class.moment = _momentTimezone2.default, _temp);
exports.default = LocaleManager;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/localization/lib/LocaleManager.js
// module id = 884
// module chunks = 6